import { Box, Link, Text, HStack } from '@chakra-ui/react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  console.log('FaGithub', FaGithub);
  return (
    <Box as="footer" bg="gray.800" color="white" py={4} textAlign="center" mt={20}>
      <HStack justify="center" spacing={4}>
        <Link href="https://github.com/xegai-hadgu" isExternal>
          <HStack spacing={1}>
            <FaGithub />
            <Text>GitHub</Text>
          </HStack>
        </Link>
        <Link href="https://www.linkedin.com/in/xegai-hadgu/" isExternal>
          <HStack spacing={1}>
            <FaLinkedin />
            <Text>LinkedIn</Text>
          </HStack>
        </Link>
      </HStack>
      <Text mt={2} fontSize="sm">
        Made with ❤️ by Xegai Hadgu
      </Text>
    </Box>
  );
};

export default Footer;
